module.exports = __webpack_public_path__ + "static/on-war-27757232036a7f8957246a5308035356.jpg";